import { PremiumCartApiAggregations } from './premium-cart-aggregations.api-config';
export const PremiumCartPublicApiConfig = {
  upsertLineItemToActiveCart: PremiumCartApiAggregations.upsertLineItemToActiveCart,
  cancelActiveCart: PremiumCartApiAggregations.cancelActiveCart
};
//# sourceMappingURL=premium-cart-public.api-config.js.map